import React from 'react';
import ClassAssembly11B from 'views/ClassAssembly11B';

const ClassAssembly11BPage = () => {
    return <ClassAssembly11B />;
  };
  
  export default ClassAssembly11BPage;

  //11B